import { lazy } from "react";
import { setStudioView } from "../workspace/studio-views";
import type { BackgroundPageProps } from "./BackgroundPage";
const BackgroundPage = lazy(() => import("./BackgroundPage").then(module => ({ default: module.BackgroundPage })));
import type { BackgroundShellProps } from "./BackgroundShell";
const BackgroundShell = lazy(() => import("./BackgroundShell").then(module => ({ default: module.BackgroundShell })));

export function mountBackgroundShell(
  slot: HTMLElement,
  p: BackgroundShellProps,
) {
  setStudioView("stage", "background-shell:" + p.projectId, <BackgroundShell {...p} />);
}

export function mountBackground(
  root: HTMLElement,
  projectId: string,
  props: BackgroundPageProps,
) {
  setStudioView("background-content", `background:${projectId}`, <BackgroundPage key={projectId} {...props} />);
}
